module.exports = __webpack_public_path__ + "img/girdRequest.f8e5c2a8.png";